<template>
  <v-container
    fill-height
    fluid
    class="d-flex flex-column justify-center align-center"
  >
    <v-container class="login">
      <h1 class="login-header">
        Biometric tablet’s<br />
        <span class="golden-text">Admin panel</span>
      </h1>
      <v-form v-model="valid" @submit.prevent="login">
        <v-text-field
          v-model="username"
          :rules="rules.username"
          label="Login / email / phone number"
          required
          outlined
          :disabled="!!$route.query.secret"
        ></v-text-field>
        <v-text-field
          v-model="password"
          @click:append="showPassword = !showPassword"
          :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          :type="showPassword ? 'text' : 'password'"
          :rules="rules.password"
          label="Password"
          :disabled="!!$route.query.secret"
          required
          outlined
        ></v-text-field>
        <v-btn
          type="submit"
          :disabled="!valid"
          class="rounded-lg auth-btn"
          width="100%"
          outlined
          large
          >Войти</v-btn
        >
      </v-form>
      <v-container class="created-by">
        <p></p>
        <img
          class="logo-svg"
          src="@/assets/svg/biometric-logo.svg"
          alt="logo"
        />
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data: () => {
    return {
      valid: false,
      username: "",
      password: "",
      showPassword: false,
      rules: {
        username: [(v) => v.length > 0 || "Имя пользователя обязательно"],
        password: [
          (v) => {
            if (v) {
              return (
                v.length >= 8 || "Длина пароля не может быть меньше 8 символов"
              );
            }
            return "Поле обязательно для заполнения";
          },
        ],
      },
    };
  },
  methods: {
    async login() {
      const payload = {
        username: this.username,
        password: this.password,
      };
      try {
        const response = await this.$axios.post("token/access/", payload);
        const tokens = {
          access: response.data.access,
          refresh: response.data.refresh,
        };
        this.$store.commit("saveTokens", tokens);
        await this.$router.push({ name: "home" });
      } catch (e) {
        this.$root.$emit(
          "showCustomError",
          "Вы ввели неверный логин или пароль"
        );
      }
    },
  },
  created() {
    const secret = this.$route.query.secret;
    if (secret) {
      this.$axios.defaults.baseURL = `${process.env.VUE_APP_BACKEND_URL}`;
      this.$axios
        .post("api-external/auth/akimat/", {
          token: secret,
        })
        .then((response) => {
          const tokens = {
            access: response.data.access,
            refresh: response.data.refresh,
          };
          this.$store.commit("saveTokens", tokens);
          this.$router.push({ name: "home" });
        })
        .catch((error) => {
          console.log(error);
          this.$root.$emit("showCustomError", "Токен недействителен");
          this.$router.push({ name: "login" });
        });
      this.$axios.defaults.baseURL = `${process.env.VUE_APP_BACKEND_URL}/api/`;
    }
    this.$store.commit("removeTokens");
  },
};
</script>

<style scoped lang="scss">
.login {
  width: 400px;
}
.login-header {
  margin-bottom: 32px;
  text-align: center;
  font-weight: 600;
  font-size: 32px;
  line-height: 38px;
  font-family: "Gilroy-Regular", sans-serif;
  color: #0b3954;

  .golden-text {
    font-weight: 700;
    line-height: 43px;
    color: #b19a13;
  }
}
.auth-btn {
  margin-top: 25px;
  font-family: "Gilroy-Regular", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  text-align: right;
  letter-spacing: 1px;

  color: #ffffff;
  text-transform: none;
  background: #3474d3;

  filter: drop-shadow(0px 2px 10px rgba(52, 116, 211, 0.3));
}
.auth-btn:disabled {
  background: #d6dfea;
  border-radius: 8px;
  filter: none;
}
.created-by {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo-svg {
    width: 335px;
    height: 60px;
  }
}
</style>
